// Central source of truth for ticket data + outbound link.
// Wix events page is the actual checkout. We open in a new tab.

export const TICKETS_URL =
  "https://www.nickfraserartist.com/event-details/nick-fraser-chapter-2?utm_source=chapter2site&utm_medium=web";

export const VENUE_URL = "https://shoreditchartsclub.com";
export const VENUE_NAME = "Shoreditch Arts Club";

export const TICKET_TIERS = [
  {
    id: "day-12",
    label: "Day Viewing",
    time: "12:00pm — 1:00pm",
    price: "£10",
    fee: "+£0.25 service fee",
    description:
      "Timed daytime entry. Access to the exhibition, projection installation, cinema screening and limited-edition print preview.",
  },
  {
    id: "day-13",
    label: "Day Viewing",
    time: "1:00pm — 2:00pm",
    price: "£10",
    fee: "+£0.25 service fee",
    description:
      "Timed daytime entry. Access to the exhibition, projection installation, cinema screening and limited-edition print preview.",
  },
  {
    id: "day-14",
    label: "Day Viewing",
    time: "2:00pm — 3:00pm",
    price: "£10",
    fee: "+£0.25 service fee",
    description:
      "Timed daytime entry. Access to the exhibition, projection installation, cinema screening and limited-edition print preview.",
  },
  {
    id: "evening",
    label: "Evening Private View",
    time: "7:00pm — 10:30pm",
    price: "£15",
    fee: "+£0.38 service fee",
    description:
      "The official evening private view. Exhibition, immersive projections, cinema screening, bar, introduction to the limited edition prints, and live performance from BoThai.",
    featured: true,
  },
];

export const TICKET_DATE = "Friday 31 July 2026";
export const TICKET_VENUE = "Shoreditch Arts Club, London";
